var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"delete-text"},[_c('img',{staticClass:"delete-text__icon",attrs:{"src":require("../assets/common_img_warm.png"),"alt":""}}),_c('div',{staticClass:"delete-text__title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"delete-text__txt"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }